import { apiClient } from "./authService";

export const requestRevenuePin = async (userId: string): Promise<any> => {
  try {
    const response = await apiClient.post("/pin/send", {
      user_id: userId,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyRevenuePin = async (
  userId: string,
  pin: string
): Promise<any> => {
  try {
    const response = await apiClient.post("/pin/verify", {
      user_id: userId,
      pin,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
